import { Api } from '@/interface/api';

/**
 * 获取用户信息
 * */

const getUserInfo: Api = {
    url: '/api/sso/proxy/api/userInfo',
    method: 'get',
};

/**
 * 获取用户是否实名认证
 */
const getIdentity: Api = {
    url: '/api/sso/proxy/api/user/certifications/identity',
    method: 'get',
};

/**
 * 获取验证码
 */
const getUserCode: Api = {
    url: '/api/sso/proxy/api/send-code/phone',
    method: 'post',
};

/**
 * 登录
 */
const postUserLogin: Api = {
    url: '/api/sso/proxy/api/login2',
    method: 'post',
};

/**
 * 退出登录
 */
const userLoginOut: Api = {
    url: '/api/sso/proxy/api/logout',
    method: 'delete',
};

/**
 * 用户信息
 */
const usersInfo: Api = {
    url: '/api/project/proxy/api/users',
    method: 'get',
};

/**
 * 获取个人已完善信息
 */
const usersGuide: Api = {
    url: '/api/project/proxy-token/api/users/guide',
    method: 'get',
};

/**
 * 获取用户profileV2信息
 */
const usersInfoV2: Api = {
    url: '/api/project/proxy-token/api/v2/users/info',
    method: 'get',
};

/**
 * 获取initData
 */
const usersInitData: Api = {
    url: '/api/project/proxy/api/users/initData',
    method: 'get',
};

/**
 * 获取usersSmartInput
 */
const usersSmartInput: Api = {
    url: '/api/project/proxy/api/users/smartInput',
    method: 'get',
};

/**
 * 更新姓名
 */
const userUpdateUserName: Api = {
    url: '/api/project/proxy-token/api/users/updateUserName',
    method: 'put',
};

/**
 * 更新邮箱
 */
 const userUpdateUserEmail: Api = {
    url: '/api/project/proxy-token/api/v2/users/save-email', 
    method: 'post',
 }

/**
 * 更新性别
 */
const usersUpdateSex: Api = {
    url: '/api/project/proxy-token/api/users/updateSex',
    method: 'put',
};

/**
 * 更新生日
 */
const usersUpdateBirthday: Api = {
    url: '/api/project/proxy-token/api/users/updateBirthday',
    method: 'put',
};

/**
 * 更新简介
 */
const usersUpdateIntro: Api = {
    url: '/api/project/proxy-token/api/users/updateIntro',
    method: 'put',
};

/**
 * 更新所在地
 */
const usersPostLocation: Api = {
    url: '/api/project/proxy-token/api/users/updateLocation',
    method: 'post',
};

/**
 * 更新所在地
 */
const usersPutLocation: Api = {
    url: '/api/project/proxy-token/api/users/updateLocation',
    method: 'put',
};

/**
 * 我的比赛
 */
const usersCmpHistory: Api = {
    url: '/api/project/proxy-token/api/users/cmpHistory',
    method: 'get',
};

/**
 * 实名认证
 */
const usersAuthData: Api = {
    url: '/api/project/proxy-token/api/users/authData',
    method: 'get',
};

/**
 * 实名认证上传保存
 */
const usersPuthAuth: Api = {
    url: '/api/project/proxy-token/api/users/auth',
    method: 'put',
};

/**
 * 实名认证上传保存
 */
const usersPostAuth: Api = {
    url: '/api/project/proxy-token/api/users/auth',
    method: 'post',
};

/**
 * 搜索学校
 */
const usersSchoolsSearch: Api = {
    url: '/api/project/proxy-token/api/users/schools/search',
    method: 'get',
};

/**
 * 搜索学校V2
 */
 const usersSchoolsSearchV2: Api = {
    url: '/api/project/proxy-token/api/common/v1/proxyEasySearch',
    method: 'post',
};

/**
 * 搜索学校V2
 */
 const usersMajorSearchV2: Api = {
    url: '/api/project/proxy-token/api/common/v1/proxyEasySearch',
    method: 'post',
};

/**
 * 搜索公司v2
 */
 const usersCompanySearchV2: Api = {
    url: '/api/project/proxy-token/api/common/v1/proxyEasySearch',
    method: 'post',
};

/**
 * 搜索职位v2
 */
 const usersJobSearchV2: Api = {
    url: '/api/project/proxy-token/api/common/v1/proxyEasySearch',
    method: 'post',
};

/**
 * 搜索专业
 */
const usersMajorSearch: Api = {
    url: '/api/project/proxy-token/api/users/major/search',
    method: 'get',
};

/**
 * 搜索公司
 */
const usersCompanySearch: Api = {
    url: '/api/project/proxy-token/api/users/company/search',
    method: 'get',
};



/**
 * 搜索职位
 */
const usersJobSearch: Api = {
    url: '/api/project/proxy-token/api/users/job/search',
    method: 'get',
};

/**
 * 搜索学历
 */
const usersEducationalSearch: Api = {
    url: '/api/project/proxy-token/api/users/educational',
    method: 'get',
};

/**
 * 保存个人信息
 */
const usersIden: Api = {
    url: '/api/project/proxy-token/api/v2/users/iden',
    method: 'post',
};

/**
 * 获取技能方向标签
 */
const usersCommonTags: Api = {
    url: '/api/project/proxy-token/api/v2/users/common-tags/tags',
    method: 'get',
};

/**
 * 获取行业领域标签
 */
const usersCommonTagsIndustry: Api = {
    url: '/api/project/proxy-token/api/v2/users/common-tags/industry',
    method: 'get',
};

/**
 * 保存技能方向标签
 */
const usersPostTags: Api = {
    url: '/api/project/proxy-token/api/v2/users/tags/skills',
    method: 'post',
};

/**
 * 删除技能方向标签
 */
const usersDeleteTags: Api = {
    url: '/api/project/proxy-token/api/v2/users/tags/skills',
    method: 'delete',
};

/**
 * 保存行业领域方向标签
 */
const usersPostIndustry: Api = {
    url: '/api/project/proxy-token/api/v2/users/tags/industry',
    method: 'post',
};

/**
 * 删除行业领域方向标签
 */
const usersDeleteIndustry: Api = {
    url: '/api/project/proxy-token/api/v2/users/tags/industry',
    method: 'delete',
};

/**
 * 发验证码
 */
const usersSendCode: Api = {
    url: '/api/project/proxy-token/api/users/send-code',
    method: 'post',
};

/**
 * 保存个人信息 学历、学校、学校专业、入学时间、毕业时间
 */
 const saveUserIdentityV2: Api = {
    url: '/api/project/proxy-token/api/v2/users/iden-v2',
    method: 'post',
};

/**
 * 保存个人信息 学历、学校、学校专业、入学时间、毕业时间
 */
 const saveUserCompanyAndJonV2: Api = {
    url: '/api/project/proxy-token/api/v2/users/iden-company-jon-v2',
    method: 'post',
};


export {
    getUserInfo,
    getIdentity,
    getUserCode,
    postUserLogin,
    userLoginOut,
    usersInfo,
    usersGuide,
    usersInfoV2,
    usersInitData,
    usersSmartInput,
    userUpdateUserName,
    userUpdateUserEmail,
    usersUpdateSex,
    usersUpdateBirthday,
    usersUpdateIntro,
    usersPostLocation,
    usersPutLocation,
    usersCmpHistory,
    usersAuthData,
    usersPuthAuth,
    usersPostAuth,
    usersSchoolsSearch,
    usersSchoolsSearchV2,
    usersMajorSearchV2,
    usersMajorSearch,
    usersCompanySearch,
    usersJobSearch,
    usersEducationalSearch,
    usersIden,
    usersCommonTags,
    usersCommonTagsIndustry,
    usersPostTags,
    usersDeleteTags,
    usersPostIndustry,
    usersDeleteIndustry,
    usersSendCode,
    saveUserIdentityV2,
    usersCompanySearchV2,
    usersJobSearchV2,
    saveUserCompanyAndJonV2
};
